var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnonymousAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_433_1",
    "data-name": "Component 433 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 319,
    height: 258,
    viewBox: "0 0 319 258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 319,
    height: 258,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1",
    "data-name": "Lag 1",
    transform: "translate(97.113 55.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(2.755 5.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lag_1-3",
    "data-name": "Lag 1-3",
    transform: "translate(0 72.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341-3",
    "data-name": "Path 341-3",
    d: "M60.382,24.34C22.658,24.34.75,36.126.75,56.3S22.658,88.232,60.382,88.232s59.632-11.786,59.632-31.961S98.135,24.34,60.382,24.34Z",
    transform: "translate(-0.75 -24.34)",
    fill: "#ff385c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lag_1-2",
    "data-name": "Lag 1",
    transform: "translate(29.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M41.482.75C22.645.75,11.69,11.571,11.69,30.074S22.645,59.4,41.482,59.4,71.273,48.577,71.273,30.074,60.318.75,41.482.75Z",
    transform: "translate(-11.69 -0.75)",
    fill: "#ff385c"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymousAvatar);
export default __webpack_public_path__ + "static/media/anonymous-avatar.63cdd2830c724bfab97fb9f32b72e59b.svg";
export { ForwardRef as ReactComponent };